import { Injectable, Pipe } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Pipe({ name: 'ReportsService' })
@Injectable()
export class ReportsService {
  constructor(private httpClient: HttpClient) { }

  //Báo cáo danh sách xuất hàng
  getAllColorPaintFormulaTempAsync(startDate: Date, endDate: Date, customerId: string, productId: string, colorId: string, userId: string) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/colorPaintFormulaTemp/getAllColorPaintFormulaTemp";
    return new Promise((resolve, reject) => {
      return this.httpClient.post(url, {
        StartDate: startDate,
        EndDate: endDate,
        CustomerId: customerId,
        ProductId: productId,
        ColorId: colorId,
        MassBook: null,
        UserId: userId
      }).toPromise()
        .then((response: Response) => {
          resolve(response);
        });
    });
  }

  //xuất excel báo cáo danh sách xuất hàng
  exportExcelAllColorPaintFormulaTempAsync(startDate: Date, endDate: Date, customerId: string, productId: string, colorId: string, userId: string) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/colorPaintFormulaTemp/exportToExcelListOrder";
    return new Promise((resolve, reject) => {
      return this.httpClient.post(url, {
        StartDate: startDate,
        EndDate: endDate,
        CustomerId: customerId,
        ProductId: productId,
        ColorId: colorId,
        MassBook: null,
        UserId: userId
      }).toPromise()
        .then((response: Response) => {
          resolve(response);
        });
    });
  }

  //
  exportExcelOutOfStock(fromDate: Date, toDate: Date) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/colorPaintFormulaTemp/exportExcelOutOfStock";
    return new Promise((resolve, reject) => {
      return this.httpClient.post(url, {
        FromDate: fromDate,
        ToDate: toDate,
      }).toPromise()
        .then((response: Response) => {
          resolve(response);
        });
    });
  }

  previewPdfOutOfStock(fromDate: Date, toDate: Date) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/colorPaintFormulaTemp/previewPdfOutOfStock";
    return new Promise((resolve, reject) => {
      return this.httpClient.post(url, {
        FromDate: fromDate,
        ToDate: toDate,
      }).toPromise()
        .then((response: Response) => {
          resolve(response);
        });
    });
  }

  //Báo cáo danh sách màu tồn (kèm file excel)
  getAllColorPaintExist(userId: string) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/colorPaintExist/getAllColorPaintExist";
    return new Promise((resolve, reject) => {
      return this.httpClient.post(url, {
        StartDate: null,
        EndDate: null,
        ProductId: null,
        ColorId: null,
        UserId: userId
      }).toPromise()
        .then((response: Response) => {
          resolve(response);
        });
    });
  }

  //Báo cáo sơn
  getReportProduct(startDate: Date, endDate: Date, userId: string) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/colorPaintFormulaTemp/getAllColorPaintFormulaTemp";
    return new Promise((resolve, reject) => {
      return this.httpClient.post(url, {
        StartDate: startDate,
        EndDate: endDate,
        CustomerId: null,
        ProductId: null,
        ColorId: null,
        MassBook: null,
        DarkColor: null,
        MixedColor: null,
        NumberColor: null,
        UserId: userId
      }).toPromise()
        .then((response: Response) => {
          resolve(response);
        });
    });
  }

  //Xuất excel báo cáo sơn
  exportToExcelPaintNameAsync(startDate: Date, endDate: Date, userId: string) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/colorPaintFormulaTemp/exportToExcelPaintName";
    return new Promise((resolve, reject) => {
      return this.httpClient.post(url, {
        StartDate: startDate,
        EndDate: endDate,
        CustomerId: null,
        ProductId: null,
        ColorId: null,
        MassBook: null,
        DarkColor: null,
        MixedColor: null,
        NumberColor: null,
        UserId: userId
      }).toPromise()
        .then((response: Response) => {
          resolve(response);
        });
    });
  }

  //Báo cáo màu
  getReportColor(startDate: Date, endDate: Date, customerId: string, productId: string, colorId: string, darkColor: boolean, mixedColor: boolean, numberColor: boolean, userId: string) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/colorPaintFormulaTemp/getAllColorPaintFormulaTemp";
    return new Promise((resolve, reject) => {
      return this.httpClient.post(url, {
        StartDate: startDate,
        EndDate: endDate,
        CustomerId: customerId,
        ProductId: productId,
        ColorId: colorId,
        MassBook: null,
        DarkColor: darkColor,
        MixedColor: mixedColor,
        NumberColor: numberColor,
        UserId: userId
      }).toPromise()
        .then((response: Response) => {
          resolve(response);
        });
    });
  }

  //xuất excel báo cáo màu
  exportToExcelColorDetail(startDate: Date, endDate: Date, customerId: string, productId: string, colorId: string, darkColor: boolean, mixedColor: boolean, numberColor: boolean, userId: string) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/colorPaintFormulaTemp/exportToExcelColorDetail";
    return new Promise((resolve, reject) => {
      return this.httpClient.post(url, {
        StartDate: startDate,
        EndDate: endDate,
        CustomerId: customerId,
        ProductId: productId,
        ColorId: colorId,
        MassBook: null,
        DarkColor: darkColor,
        MixedColor: mixedColor,
        NumberColor: numberColor,
        UserId: userId
      }).toPromise()
        .then((response: Response) => {
          resolve(response);
        });
    });
  }

  //Báo cáo màu đậm
  getReportDeepColor(startDate: Date, endDate: Date, mixedColor: boolean, userId: string) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/colorPaintFormulaTemp/getAllColorPaintFormulaTemp";
    return new Promise((resolve, reject) => {
      return this.httpClient.post(url, {
        StartDate: startDate,
        EndDate: endDate,
        CustomerId: null,
        ProductId: null,
        ColorId: null,
        MassBook: null,
        DarkColor: true,
        MixedColor: mixedColor,
        NumberColor: null,
        UserId: userId
      }).toPromise()
        .then((response: Response) => {
          resolve(response);
        });
    });
  }

  //xuất excel báo cáo màu đậm
  exportToExcelDarkColor(startDate: Date, endDate: Date, mixedColor: boolean, userId: string) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/colorPaintFormulaTemp/exportToExcelDarkColor";
    return new Promise((resolve, reject) => {
      return this.httpClient.post(url, {
        StartDate: startDate,
        EndDate: endDate,
        CustomerId: null,
        ProductId: null,
        ColorId: null,
        MassBook: null,
        DarkColor: true,
        MixedColor: mixedColor,
        NumberColor: null,
        UserId: userId
      }).toPromise()
        .then((response: Response) => {
          resolve(response);
        });
    });
  }

  //Báo cáo nhập sơn
  getReportIncludeProduct(startDate: Date, endDate: Date, userId: string) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/importPaint/getAllImportPaint";
    return new Promise((resolve, reject) => {
      return this.httpClient.post(url, {
        StartDate: startDate,
        EndDate: endDate,
        UserId: userId
      }).toPromise()
        .then((response: Response) => {
          resolve(response);
        });
    });
  }

  //Báo cáo nhập màu
  getReportIncludeColor(startDate: Date, endDate: Date, userId: string) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/importColor/getAllImportColor";
    return new Promise((resolve, reject) => {
      return this.httpClient.post(url, {
        StartDate: startDate,
        EndDate: endDate,
        UserId: userId
      }).toPromise()
        .then((response: Response) => {
          resolve(response);
        });
    });
  }

  //Báo cáo tồn kho sơn
  getReportProductRest(userId: string) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/paintStore/getAllPaintStore";
    return new Promise((resolve, reject) => {
      return this.httpClient.post(url, {
        UserId: userId
      }).toPromise()
        .then((response: Response) => {
          resolve(response);
        });
    });
  }

  //Báo cáo tồn kho màu
  getReportColorRest(userId: string) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/colorStore/getAllColorStore";
    return new Promise((resolve, reject) => {
      return this.httpClient.post(url, {
        UserId: userId
      }).toPromise()
        .then((response: Response) => {
          resolve(response);
        });
    });
  }

  //Báo cáo vắn tắt
  getReportBriefly(startDate: Date, endDate: Date, userId: string) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/colorPaintFormulaTemp/reportColorMixFormula";
    return new Promise((resolve, reject) => {
      return this.httpClient.post(url, {
        StartDate: startDate,
        EndDate: endDate,
        UserId: userId
      }).toPromise()
        .then((response: Response) => {
          resolve(response);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/reports.service.ts